export const API_VERSION = 'v1';
export const DEFAULT_SEARCH_PAGE_SIZE = 20;
export const DEFAULT_SEARCH_PAGE_NUM = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE_LOAD_MORE = 10;
export const DEFAULT_PAGE_SIZE_FULL = 100;

export const EXTERNAL_CSV_COLUMN = {
    lineitem_taxExemptionDetails: '',
    lineitem_amountTaxExempted: 0,
    lineitem_quantity: 1,
    lineitem_measurement: '',
    lineitem_discountRate: 0,
    lineitem_discountAmount: 0,
    lineitem_discountReason: '',
    lineitem_feeChargeRate: 0,
    lineitem_feeChargeAmount: 0,
    lineitem_feeChargeReason: '',
    lineitem_productTariffCode: '',
    lineitem_countryOfOrigin: 'MYS',
    currency_exchange_rate: 1,
    frequency_of_billing: 'Daily',
    billing_period_start_date: '',
    billing_period_end_date: '',
    payment_mode: '',
    suppliers_bank_account_number: '',
    payment_terms: '',
    pre_payment_amount: 0,
    pre_payment_date: '',
    pre_payment_time: '',
    pre_payment_reference_number: '',
    total_discount_value: 0,
    total_fee_charge_amount: 0,
    rounding_amount: 0,
    tax_exemption_details: 0,
    invoice_additional_discount_amount: 0,
    invoice_additional_fee_amount: 0,
    shipping_recipient_name: 'John',
    shippingRecipientAddress_line0: 'NA',
    shippingRecipientAddress_line1: 'NA',
    shippingRecipientAddress_line2: 'NA',
    shippingRecipientAddress_postal: 9000,
    shippingRecipientAddress_city: 'Sandakan',
    shippingRecipientAddress_state: '03',
    shippingRecipientAddress_country: 'MYS',
    shipping_recipient_tin: '',
    shipping_recipient_registration_number_type: 'BRN',
    shipping_recipient_registration_number: 'NA',
    custom_form_ref_no: '1111',
    incoterms: 'FOB',
    free_trade_agreement: 'ASEAN-Australia-New Zealand FTA (AANZFTA)',
    authorisation_number: '',
    custom_form_ref_no2: '',
    shipment_allowanceChargeReason: '',
    shipment_amount: 0,
    shipping_address_state: '03',
    date_of_issue: '',
};
